"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// src/data/Products_17.ts
const product_types_1 = require("../types/product.types");
const products = [
    // 1316. Curs Desbloqueig Mental Físiques (Valla i Plint) 2026 [2h] (2026)
    {
        id: 1316,
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.classroom.curs-desbloqueig-mental-fisiques-2026",
        title: "Curs Desbloqueig Mental Físiques (Valla i Plint) 2026 [2h]",
        name: "Curs Desbloqueig Mental Físiques (Valla i Plint) 2026 [2h]",
        category: [product_types_1.Category.Sports, product_types_1.Category.FaceToFace],
        description: "Supera la por, trenca els bloquejos i arriba al dia de la prova amb el control total: domina la tanca i el plintó amb el mètode mental d’iOpos.",
        enabled: true,
        stock: true,
        stock_message: "Places exhaurides!",
        price: 24.99,
        shipment: 0.0,
        images: ["/944/image1"],
        banner: ["/944/image1"],
        link: "/tienda/cursos/curs-desbloqueig-mental-fisiques-valla-i-plint-2026/",
        created_at: "2026-10-20 00:00:01",
        start_at: "2026-10-20 00:00:01",
        more_info: true,
        can_be_sent: false,
        items: 1,
        discount_not_applicable: true,
        childs: [1317, 1319],
    },
    // 1317. Curs Desbloqueig Mental Físiques (Valla i Plint) 2026 [2h] (31/10/2026 9:30 a 11:30 h)
    {
        id: 1317,
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.classroom.curs-desbloqueig-mental-fisiques-31_10_2026-930-1130",
        title: "Curs Desbloqueig Mental Físiques (Valla i Plint) 31/10/2026 9:30 a 11:30 h [2h]",
        name: "Curs Desbloqueig Mental Físiques (Valla i Plint) 31/10/2026 9:30 a 11:30 h [2h]",
        short: "Sessió 31/10/2026) 9:30 a 11:30 h [2h] - Desbloqueig Mental Físiques (Valla i Plint)",
        category: [product_types_1.Category.Sports, product_types_1.Category.FaceToFace],
        description: "Supera la por, trenca els bloquejos i arriba al dia de la prova amb el control total: domina la tanca i el plintó amb el mètode mental d’iOpos.",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        price: 24.99,
        shipment: 0.0,
        images: ["/944/image1"],
        banner: ["/944/image1"],
        // link: "/tienda/cursos/-/",
        created_at: "2026-10-20 00:00:01",
        start_at: "2026-10-20 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        discount_not_applicable: true,
        parent: 1316,
    },
    // 1318. Simulacre de Físiques CrossFit Lynx Sant Cugat, 22/11/2025 (16-18h)
    {
        id: 1318,
        type: product_types_1.Type.Course,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.simulacre-proves-fisiques-mossos-crossfit-lynx-sant-cugat-22_11_2026-17-19",
        title: "Simulacre de Físiques CrossFit Lynx Sant Cugat, 22/11/2026 (17-19h)",
        name: "Simulacre de Físiques CrossFit Lynx Sant Cugat, 22/11/2026 (17-19h)",
        category: [product_types_1.Category.Sports, product_types_1.Category.FaceToFace],
        description: "Descobreix el teu nivell real, posa a prova les teves marques i prepara't per superar les proves físiques de Mossos d'Esquadra amb confiança!",
        enabled: true,
        stock: true,
        stock_message: "Places exhaurides!",
        price: 24.99,
        shipment: 0.0,
        images: ["/1318/image_h"],
        banner: ["/1318/image_H"],
        link: "/tienda/cursos/simulacre-proves-fisiques-mossos-desquadra-crossfit-lynx-sant-cugat-22-11-2026-17-19/",
        created_at: "2026-10-30 00:00:01",
        start_at: "2026-10-30 00:00:01",
        more_info: true,
        can_be_sent: false,
        items: 1,
        hero: {
            firstTitle: "Simulacre de Proves Físiques al CrossFit Lynx",
            secondTitle: "Mossos d'Esquadra 2026",
            thirdTitle: "Posa a prova el teu nivell **abans de l'examen oficial!**",
            landscape: "/1318/hero_h.jpg",
            portrait: "/1318/hero_v.jpg",
        },
        productImage: {
            landscape: "/1318/image_h.jpg",
            portrait: "/1318/image_h.jpg",
        },
        limit: 50,
    },
    // 1319. Curs Desbloqueig Mental Físiques (Valla i Plint) 2026 [2h] (07/11/2026 9:30 a 11:30 h)
    {
        id: 1319,
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.classroom.curs-desbloqueig-mental-fisiques-07_11_2026-930-1130",
        title: "Curs Desbloqueig Mental Físiques (Valla i Plint) 07/11/2026 9:30 a 11:30 h [2h]",
        name: "Curs Desbloqueig Mental Físiques (Valla i Plint) 07/11/2026 9:30 a 11:30 h [2h]",
        short: "Sessió 07/11/2026) 9:30 a 11:30 h [2h] - Desbloqueig Mental Físiques (Valla i Plint)",
        category: [product_types_1.Category.Sports, product_types_1.Category.FaceToFace],
        description: "Supera la por, trenca els bloquejos i arriba al dia de la prova amb el control total: domina la tanca i el plintó amb el mètode mental d’iOpos.",
        enabled: true,
        stock: true,
        stock_message: "Places exhaurides!",
        price: 24.99,
        shipment: 0.0,
        images: ["/944/image1"],
        banner: ["/944/image1"],
        // link: "/tienda/cursos/-/",
        created_at: "2026-10-31 00:00:01",
        start_at: "2026-10-31 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        discount_not_applicable: true,
        parent: 1316,
    },
];
exports.default = products;
